import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpunestation() {



    const cardData =
    {
        keyword: 'Urbania on Rent in Pune Station',
        heading: 'Urbania on rent in pune: Urbania on Rent in Pune Station ',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania on Rent in Pune Station for corporate groups, families, tourists, and event transportation needs. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for railway station pickups and drops, airport transfers, corporate travel, weddings, sightseeing, and outstation journeys from Pune Station. With professional chauffeurs, flexible one-way and round-trip rental options, and timely pickup from Pune Railway Station, Shivajinagar, Camp, Swargate, Koregaon Park, and Pune Airport, we ensure a safe and hassle-free travel experience. Backed by 24/7 booking support, punctual service, and competitive pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire at Pune Station.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark and a symbol of Maratha power. Once the administrative seat of Bajirao I, the fort complex featured grand halls, fountains, and courtyards. Although a major fire destroyed much of the structure, the massive stone walls, gates like the Delhi Darwaza, and remaining ruins still reflect its former grandeur. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit heritage attraction."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Aga Khan Palace is a significant monument linked to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. Surrounded by lush gardens and Italian-style arches, the palace offers a peaceful yet historically powerful experience."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Sinhagad Fort stands atop a rugged hill in the Sahyadri range and is renowned for the heroic sacrifice of Tanaji Malusare in 1670. The fort offers breathtaking panoramic views of Pune and surrounding valleys. Visitors can trek or drive to explore ancient ramparts, memorials, and gates. Local food stalls serving traditional pithla-bhakri add to the authentic experience, making it a favorite spot for history lovers and adventure seekers."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The beautifully adorned idol, decorated with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations with processions and cultural events. The temple trust is also known for its social and charitable initiatives, making it both a spiritual and cultural landmark."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy area, the temple offers a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s lesser-known yet spiritually rich heritage sites."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar to preserve Indian art and culture. Exhibits include musical instruments, sculptures, lamps, utensils, and traditional household items. The recreated Mastani Mahal is a major highlight. The museum offers a deep insight into India’s cultural diversity and traditional craftsmanship."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after climbing 103 stone steps. The hilltop temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. Smaller temples and a museum enrich the visit. Sunrise and sunset views from the hill are especially popular among locals and tourists."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous center for meditation and mindfulness. Spread across landscaped gardens, it offers meditation programs, wellness therapies, and spiritual retreats. Visitors from across the globe come here seeking inner peace, relaxation, and personal transformation, making it an international spiritual destination."
            },
            {
                "title": "Pu La Deshpande Garden",
                "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for morning walks, family outings, and photography, the garden blends Japanese aesthetics with Indian natural beauty, offering a serene green escape."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The vast reservoir, cool breeze, and surrounding hills create a refreshing atmosphere, especially during monsoon and evenings. Street vendors selling corn and tea add local charm. It also serves as a gateway to Sinhagad Fort, making it a scenic leisure destination."
            }
        ],



"services": [
{
"name": "Urbania on Rent in Pune Station",
"description": "Urbania on Rent in Pune Station provides spacious and comfortable Urbania vehicles for city travel, family outings, corporate trips, and special events. The service includes well-maintained vehicles, professional chauffeurs, smooth rides, ample luggage space, and easy booking with transparent pricing."
},
{
"name": "Urbania Bus Hire Pune Station",
"description": "Urbania Bus Hire Pune Station offers reliable group transportation for tours, corporate trips, school outings, and social events. With clean interiors, experienced drivers, and punctual pickups, this service ensures safe and convenient travel for groups in Pune Station and nearby areas."
},
{
"name": "Urbania Rental Service Pune Station",
"description": "Urbania Rental Service Pune Station provides flexible rental solutions for short-term, full-day, and multi-day travel. Suitable for local travel, outstation trips, and customized itineraries, the service ensures well-maintained vehicles, professional chauffeurs, and consistent service quality."
},
{
"name": "Urbania AC Bus on Rent Pune Station",
"description": "Urbania AC Bus on Rent Pune Station offers fully air-conditioned Urbania vehicles for a comfortable and premium travel experience. Ideal for corporate travel, long-distance trips, and group tours, these AC buses ensure smooth rides and professional chauffeur service."
},
{
"name": "Urbania Corporate Bus Hire Pune Station",
"description": "Urbania Corporate Bus Hire Pune Station provides professional transportation for corporate events, office trips, conferences, and employee commutes. Well-maintained vehicles, trained drivers, and punctual service ensure seamless corporate travel."
},
{
"name": "Urbania for Outstation from Pune Station",
"description": "Urbania for Outstation from Pune Station offers safe and comfortable long-distance travel with highway-trained chauffeurs and reliable vehicles. Perfect for business trips, weekend getaways, pilgrimages, and multi-city tours."
},
{
"name": "Urbania Airport Transfer Pune Station",
"description": "Urbania Airport Transfer Pune Station ensures timely and hassle-free airport pickups and drops for families, tourists, and corporate travelers. With ample luggage space, professional chauffeurs, and punctual service, this option is ideal for group airport transfers."
},
{
"name": "Urbania for Office Trips Pune Station",
"description": "Urbania for Office Trips Pune Station offers dependable transportation for daily office commutes, team outings, and corporate events. The service emphasizes comfort, safety, and punctuality for smooth office travel."
},
{
"name": "Urbania for Marriage Events Pune Station",
"description": "Urbania for Marriage Events Pune Station provides elegant and reliable transportation for weddings, guests, and family members. Professional chauffeurs, clean vehicles, and timely service ensure smooth coordination for all wedding-related travel needs."
},
{
"name": "Urbania Luxury Bus Hire Pune Station",
"description": "Urbania Luxury Bus Hire Pune Station delivers high-end Urbania vehicles with plush interiors, comfortable seating, and premium travel experience. Ideal for VIP guests, corporate executives, weddings, and luxury group tours."
},
{
"name": "Affordable Urbania on Rent Pune Station",
"description": "Affordable Urbania on Rent Pune Station offers budget-friendly rental solutions without compromising on comfort or safety. Perfect for families, corporate travel, and group outings, featuring well-maintained vehicles and professional chauffeurs."
},
{
"name": "Urbania for Family Tours Pune Station",
"description": "Urbania for Family Tours Pune Station ensures safe, comfortable, and enjoyable travel for family trips. Spacious seating, luggage capacity, and courteous chauffeurs make it ideal for vacations, leisure outings, and religious tours."
},
{
"name": "Urbania Chauffeur Driven Urbania Pune Station",
"description": "Urbania Chauffeur Driven Urbania Pune Station offers stress-free travel with trained, background-verified chauffeurs experienced in city and highway driving. Perfect for corporate, family, and outstation travel, focusing on safety, comfort, and punctuality."
},
{
"name": "Urbania Group Travel Pune Station",
"description": "Urbania Group Travel Pune Station provides organized and comfortable transportation for groups traveling together. Suitable for tours, corporate outings, social events, and excursions, ensuring coordinated travel and smooth rides."
},
{
"name": "Best Urbania on Rent in Pune Station",
"description": "Best Urbania on Rent in Pune Station delivers top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Trusted for local, outstation, and event travel, ensuring comfortable, timely, and dependable service."
}
],
"tableData": [
["Urbania on Rent in Pune Station", "Urbania Bus Hire Pune Station"],
["Urbania Rental Service Pune Station", "Urbania AC Bus on Rent Pune Station"],
["Urbania Corporate Bus Hire Pune Station", "Urbania for Outstation from Pune Station"],
["Urbania Airport Transfer Pune Station", "Urbania for Office Trips Pune Station"],
["Urbania for Marriage Events Pune Station", "Urbania Luxury Bus Hire Pune Station"],
["Affordable Urbania on Rent Pune Station", "Urbania for Family Tours Pune Station"],
["Urbania Chauffeur Driven Urbania Pune Station", "Urbania Group Travel Pune Station"],
["Best Urbania on Rent in Pune Station", ""]
],





"whychoose": [
    {
        "WhyChooseheading": "Best Urbania on Rent in Pune Station",
        "WhyChoosedescription": "Urbania on Rent in Pune Station is an ideal choice for comfortable and spacious group travel, suitable for corporate trips, family outings, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania on Rent in Pune Station offers premium Force Urbania vehicles with modern interiors, ample legroom, and air-conditioning for a smooth travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania on Rent in Pune Station comes with skilled drivers who are familiar with local routes and highways, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania on Rent in Pune Station for competitive pricing with no hidden charges, making group travel reliable and budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania on Rent in Pune Station includes round-the-clock support for bookings, inquiries, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania on Rent in Pune Station is available for hourly rentals, full-day bookings, corporate travel, wedding transportation, and customized outstation packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania on Rent in Pune Station are regularly serviced and sanitized to ensure a clean, safe, and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania on Rent in Pune Station guarantees on-time pickups and dependable service, ensuring smooth and stress-free group travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania on Rent in Pune Station available for local and outstation travel?',
        answer: 'Yes, Urbania on Rent in Pune Station is available for both local city travel and outstation journeys, offering a premium and comfortable travel experience.',
    },
    {
        question: 'How can I book Urbania on Rent in Pune Station?',
        answer: 'You can easily book Urbania on Rent in Pune Station through phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania on Rent in Pune Station for group travel?',
        answer: 'Urbania on Rent in Pune Station offers spacious seating, luxury interiors, ample luggage space, and smooth ride quality, making it ideal for group, family, and corporate travel.',
    },
    {
        question: 'Is Urbania on Rent in Pune Station suitable for corporate and event travel?',
        answer: 'Yes, Urbania on Rent in Pune Station is perfect for corporate trips, airport transfers, weddings, events, and business meetings.',
    },
    {
        question: 'Are drivers experienced with Urbania on Rent in Pune Station?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safety and comfort.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania on Rent in Pune Station?',
        answer: 'Absolutely. Urbania on Rent in Pune Station allows flexible pickup and drop-off locations across Pune Station and nearby areas.',
    },
    {
        question: 'Is Urbania on Rent in Pune Station available 24x7?',
        answer: 'Yes, Urbania on Rent in Pune Station operates 24x7 to meet your travel needs at any time of the day or night.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania on Rent in Pune Station?',
        answer: 'Yes, all vehicles are regularly sanitized and maintained, and strict safety protocols are followed for every trip.',
    },
    {
        question: 'What payment options are available for Urbania on Rent in Pune Station?',
        answer: 'Urbania on Rent in Pune Station accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajit Kulkarni',
        feedback: 'We booked Urbania on Rent in Pune Station for a family event. The vehicle was spacious, clean, and extremely comfortable. Great experience!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rutuja Deshmukh',
        feedback: 'Urbania on Rent in Pune Station provided excellent service for our corporate trip. Professional driver and smooth ride. Highly recommended.',
        rating: 5,
    },
];


















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Pune Station",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-on-rent-pune-station.jpg",
  "description": "Urbania on Rent in Pune Station provides premium Force Urbania bus rental services for corporate travel, office trips, marriage events, family tours, airport transfers, group travel, and outstation journeys. Luxury AC Urbania buses with professional chauffeur-driven service are available at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-pune-station"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania on Rent in Pune Station | Luxury Urbania Bus Hire & Group Travel 
  </title>

  <meta
    name="description"
    content="Book Urbania on Rent in Pune Station for corporate travel, office trips, marriage events, family tours, airport transfers, group travel, and outstation journeys. Luxury AC Urbania bus hire with chauffeur-driven service at affordable rates."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Pune Station, Urbania Bus Hire Pune Station, Urbania Rental Service Pune Station, Urbania AC Bus on Rent Pune Station, Urbania Corporate Bus Hire Pune Station, Urbania for Outstation from Pune Station, Urbania Airport Transfer Pune Station, Urbania for Office Trips Pune Station, Urbania for Marriage Events Pune Station, Urbania Luxury Bus Hire Pune Station, Affordable Urbania on Rent Pune Station, Urbania for Family Tours Pune Station, Urbania Chauffeur Driven Urbania Pune Station, Urbania Group Travel Pune Station, Best Urbania on Rent in Pune Station"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpunestation;